import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { Select } from "antd";
import { GET_MANAGERS, GET_ROLES } from "../../services/commonServices";
// import { BASE_API_URL } from "../../services/baseServices";
import { ADD_USER } from "../../services/userServices";
import { fetchModules } from "../../services/authServices";
import { fetchOrganizations } from "../../services/organizationServices";
import { fetchWithAuth } from "../../utils/api";
import { fetchDepartments } from "../../services/departmentsServices";

export default function AddUser() {

    const [sessionUserData, setsessionUserData] = useState({});
    const [rolesData, setRolesData] = useState([]);
    const [addSubmitLoading, setAddSubmitLoading] = useState(false);
    const [modules, SetModules] = useState([]);
    const [organizations, SetOrganizations] = useState([]);
    const [manager, setManager] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [selectedModules, setSelectedModules] = useState([]);
    const [departmentsData, setDepartmentsData] = useState([]);
    const [emailError, setEmailError] = useState('');
    const { Option } = Select;

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const [formData, setFormData] = useState({
        RoleId: "",
        Name: "",
        DeptId: "",
        Password: "",
        IsActive: 1,
        CreatedBy: "",
        OrgId: "",
        Mobile: "",
        Email: "",
        IsMobile: 1,
        Gender: "",
        NotifyEmail: "",
        ManagerId: "",
        AccessToModules: "",
        Image: "",
    });

    const [imagePreview, setImagePreview] = useState("");

    const fetchManagerData = async () => {
        try {
            const response = await fetchWithAuth(`${GET_MANAGERS}?OrgId=${formData?.OrgId}`, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                setManager(data.ResultData);
            } else {
                console.error('Failed to fetch shifts data:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching shifts data:', error.message);
        }
    };

    useEffect(() => {
        if (formData.OrgId) {
            fetchManagerData();
        }
    }, [formData.OrgId]);

    const getDepartments = async () => {
        try {
            const data = await fetchDepartments(formData?.OrgId);
            setDepartmentsData(data);
        } catch (error) {
            console.error('Failed to load departments:', error);
        }
    };

    useEffect(() => {
        if (formData?.OrgId) {
            getDepartments();
        }
    }, [formData?.OrgId]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setsessionUserData(userData);
            setFormData((prev) => ({
                ...prev,
                CreatedBy: userData.Id,
            }));
        }
    }, []);

    const fetchRolesData = async () => {
        if (sessionUserData.OrgId) {
            try {
                const response = await fetchWithAuth(`${GET_ROLES}`, {
                    method: 'GET',
                });
                if (response.ok) {
                    const data = await response.json();
                    setRolesData(data.ResultData);
                } else {
                    console.error('Failed to fetch attendance data:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching attendance data:', error.message);
            }
        }
    };

    const getModules = async () => {
        try {
            const data = await fetchModules();
            SetModules(data);
        } catch (error) {
            console.error('Failed to load modules:', error);
        } finally {
            console.log('Organization fetch completed');
        }
    };
    const getOrganizations = async () => {
        try {
            const data = await fetchOrganizations();
            SetOrganizations(data);
        } catch (error) {
            console.error('Failed to load modules:', error);
        } finally {
            console.log('Organization fetch completed');
        }
    };

    useEffect(() => {
        getModules();
        getOrganizations();
    }, []);

    useEffect(() => {
        if (sessionUserData.OrgId) {
            fetchRolesData();
        }
    }, [sessionUserData]);

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            Swal.fire({
                title: "Invalid File",
                text: "Only PNG, JPG, and JPEG files are allowed.",
                icon: "error",
            });
            e.target.value = "";
            return;
        }

        setFormData((prev) => ({
            ...prev,
            Image: file,
        }));

        setImagePreview(URL.createObjectURL(file));
    };

    const handleInputChange = (eOrValue, nameFromSelect = null) => {
        if (nameFromSelect) {
            setFormData((prev) => ({
                ...prev,
                [nameFromSelect]: eOrValue || "",
            }));
            return;
        }

        const { name, value, type, checked } = eOrValue.target;

        if (name === 'Mobile') {
            if (!/^\d{0,10}$/.test(value)) {
                Swal.fire({
                    title: "Invalid Input",
                    text: "Please enter a valid 10-digit mobile number without letters or special characters.",
                    icon: "error",
                });
                return;
            }
        }

        let formattedValue = value;
        // if (name === 'Name') {
        //     formattedValue = toTitleCase(value.replace(/\s+/g, ''));
        // }

        setFormData((prevState) => ({
            ...prevState,
            [name]: type === "checkbox" ? (checked ? 1 : 0) : formattedValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAddSubmitLoading(true);
        if (formData.Image) {
            console.log("Image Size:", formData.Image.size / 1024 / 1024, "MB");
        }

        if (!/^\d{10}$/.test(formData.Mobile)) {
            Swal.fire({
                title: "Invalid Mobile Number",
                text: "Mobile number must be exactly 10 digits.",
                icon: "error",
            });
            setAddSubmitLoading(false);
            return;
        }

        if (!validateEmail(formData.Email)) {
            setEmailError("Please enter a valid email ending with ex: .com or .in");
            setAddSubmitLoading(false);
            return;
        }

        try {
            const payload = new FormData();

            payload.append("RoleId", formData.RoleId || "");
            payload.append("Name", formData.Name || "");
            payload.append("DeptId", formData.DeptId || "");
            payload.append("Password", formData.Password || "");
            payload.append("IsActive", "1");
            payload.append("CreatedBy", sessionUserData?.Id || "");
            payload.append("OrgId", formData.OrgId || "");
            payload.append("Mobile", formData.Mobile || "");
            payload.append("Email", formData.Email || "");
            payload.append("IsMobile", "1");
            payload.append("Gender", formData.Gender || "");
            payload.append("NotifyEmail", formData.NotifyEmail || "");
            payload.append("ManagerId", formData.ManagerId || "");
            payload.append("IsSuperiorId", formData.ManagerId || "");
            payload.append("AccessToModules", selectedModules.join(","));

            if (formData.Image) {
                payload.append("ImageUrl", formData.Image);
            }
            for (const [key, value] of payload.entries()) {
                console.log(`${key}:`, value);
            }

            const response = await fetchWithAuth(`${ADD_USER}`, {
                method: "POST",
                body: payload,
            });

            const data = await response.json();

            if (data.ResultData?.Status === "Success") {
                Swal.fire({
                    title: "Success",
                    text: "User has been added successfully.",
                    icon: "success",
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: data?.ResultData?.ResultMessage || "Failed to add user.",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error during submission:", error.message);
            Swal.fire({
                title: "Error",
                text: "An unexpected error occurred.",
                icon: "error",
            });
        } finally {
            setAddSubmitLoading(false);
        }
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.(com|in|gov|tech|info|org|net|us|edu|shop|dev)$/i;
        return regex.test(email);
    };


    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRightAdd"
            aria-labelledby="offcanvasRightLabel"
            style={{ width: "90%" }}
        >
            <style>
                {`
                    @media (min-width: 768px) { /* Medium devices and up (md) */
                        #offcanvasRightAdd {
                            width: 50% !important;
                        }
                    }
                `}
            </style>
            <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <h5 id="offcanvasRightLabel" className="mb-0">Add User</h5>
                    <div className="d-flex align-items-center">
                        <button className="btn btn-primary btn-sm me-2" type="submit" disabled={addSubmitLoading}>
                            {addSubmitLoading ? "Submitting..." : "Submit"}
                        </button>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <hr />
                <div className="offcanvas-body" style={{ maxHeight: "42rem", overflowY: "auto" }}>
                    <div className="row">
                        <div className="col-6 mb-2">
                            <label className="form-label">User Name<span className="text-danger">*</span></label>
                            <input
                                type="text"
                                name="Name"
                                className="form-control"
                                placeholder="Enter user name"
                                value={formData.Name}
                                onChange={handleInputChange}
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div className="col-6 mb-2 position-relative">
                            <label className="form-label">
                                Password <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="Password"
                                    className="form-control"
                                    placeholder="Enter password"
                                    value={formData.Password}
                                    autoComplete="new-password"
                                    onChange={handleInputChange}
                                    required
                                />
                                <span className="input-group-text" style={{ cursor: "pointer" }} onClick={togglePasswordVisibility}>
                                    {showPassword ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}
                                </span>
                            </div>
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">
                                Organization <span className="text-danger">*</span>
                            </label>
                            <Select
                                showSearch
                                allowClear
                                placeholder="Select Organization"
                                className="w-100"
                                value={formData.OrgId || undefined}
                                style={{ height: '2.4rem' }}
                                onChange={(value) => handleInputChange(value, "OrgId")}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {organizations?.map((org) => (
                                    <Option key={org.OrgId} value={org.OrgId}>
                                        {org.OrgName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">
                                Department <span className="text-danger">*</span>
                            </label>
                            <Select
                                showSearch
                                allowClear
                                placeholder="Select Department"
                                className="w-100"
                                value={formData.DeptId || undefined}
                                style={{ height: '2.4rem' }}
                                onChange={(value) => handleInputChange(value, "DeptId")}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {departmentsData?.map((org) => (
                                    <Option key={org.Id} value={org.Id}>
                                        {org.DeptName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">
                                Role <span className="text-danger">*</span>
                            </label>
                            <Select
                                showSearch
                                allowClear
                                placeholder="Select Role"
                                className="w-100"
                                value={formData.RoleId || undefined}
                                style={{ height: '2.4rem' }}
                                onChange={(value) => handleInputChange(value, "RoleId")}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {rolesData?.map((role) => (
                                    <Option key={role.Id} value={role.Id}>
                                        {role.Name}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                        <div className="col-6 mb-2">
                            <label className="form-label">Mobile<span className="text-danger">*</span></label>
                            <div className="input-group">
                                <span className="input-group-text">🇮🇳 +91</span>
                                <input
                                    type="tel"
                                    name="Mobile"
                                    className="form-control"
                                    placeholder="Enter 10-digit mobile number"
                                    value={formData.Mobile}
                                    onChange={handleInputChange}
                                    maxLength={10}
                                    pattern="[0-9]{10}"
                                    required
                                />
                            </div>
                        </div>

                        <div className="col-6 mb-2">
                            <label className="form-label">Email<span className="text-danger">*</span></label>
                            <input
                                type="email"
                                name="Email"
                                className={`form-control ${emailError ? 'is-invalid' : ''}`}
                                placeholder="Enter email address"
                                value={formData.Email}
                                onChange={handleInputChange}
                                required
                            />
                            {emailError && <div className="invalid-feedback">{emailError}</div>}

                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">Gender<span className="text-danger">*</span></label>
                            <select
                                className="form-select"
                                name="Gender"
                                value={formData.Gender}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select Gender</option>
                                <option value="1">Male</option>
                                <option value="0">Female</option>
                            </select>
                        </div>

                        <div className="col-6 mb-2 d-flex flex-column">
                            <label className="form-label">Manager<span className="text-danger">*</span></label>
                            <Select
                                placeholder="Select Manager"
                                showSearch
                                allowClear
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                                value={formData.ManagerId || undefined}
                                onChange={(value) => handleInputChange(value, "ManagerId")}
                                style={{ height: '2.4rem' }}
                            >
                                {manager?.map((item) => (
                                    <Option key={item.Id} value={item.Id}>
                                        {item.Name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-6 mb-2 d-flex flex-column">
                            <label className="form-label">Modules<span className="text-danger">*</span></label>
                            <Select
                                mode="multiple"
                                placeholder="Select Modules"
                                showSearch
                                allowClear
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                                value={selectedModules}
                                onChange={(value) => setSelectedModules(value)}
                                style={{ height: 'auto', minHeight: '2.4rem' }}
                            >
                                {modules?.map((item) => (
                                    <Option key={item.Id} value={item.Id}>
                                        {item.ModuleName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">Profile Image</label>
                            <input
                                type="file"
                                name="Image"
                                className="form-control"
                                accept=".png,.jpg,.jpeg"
                                onChange={handleImageChange}
                            />
                            <small className="text-muted">Only PNG, JPG, JPEG allowed</small>
                        </div>
                    </div>
                    <div className="col-6 mb-2">
                        <label className="form-label">Image Preview</label>
                        <div>
                            {imagePreview ? (
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{
                                        width: "120px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "12px",
                                        border: "1px solid #dee2e6",
                                    }}
                                />
                            ) : (
                                <div className="text-muted">No image selected</div>
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
